<template>
  <v-container fluid>
    <v-card v-show="!editPage && !confirmPage" flat>
      <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">{{
        wordList.lbl_operator_list
      }}</v-card-title>
      <v-card-text>
        <v-card :flat="true">
          <!-- 検索条件入力 { -->
          <v-expansion-panels v-model="panel" flat multiple class="br_1">
            <v-expansion-panel>
              <v-expansion-panel-title
                class="py-0 font-weight-bold bk_gray_3"
                >{{ wordList.lbl_search }}</v-expansion-panel-title
              >
              <v-expansion-panel-text class="bk_gray_3" eager>
                <v-divider class="mb-5"/>
                <Form v-if="isWordListReady" ref="searchFormRef" :initial-values="formInitialValues" v-slot="{ meta }">
                  <v-card class="bk_gray_3" flat>
                    <v-card-text>
                      <v-row class="mt-0">
                        <!-- チェーン -->
                        <v-col
                          v-if="chainViewFlag"
                          cols="12"
                          sm="6"
                          md="4"
                          class="py-0"
                        >
                          <Field
                            v-slot="{ field, errors }"
                            name="chainName"
                            :label="wordList.lbl_chain_name"
                            rules="required"
                          >
                            <v-autocomplete
                              :model-value="field.value ?? chainSelectValues"
                              density="compact"
                              :items="chainListItems"
                              item-title="name"
                              item-value="chain_code"
                              :label="wordList.lbl_chain_name"
                              :placeholder="wordList.plc_selectbox"
                              :error-messages="errors"
                              :no-data-text="wordList.lbl_no_data_text"
                              hint="必須"
                              bg-color="white"
                              return-object
                              variant="outlined"
                              @update:model-value="
                                (val) => {
                                  field.onChange(val);
                                  chainSelectValues = val;
                                  onChangeChain();
                                }
                              "
                              @blur="field.onBlur"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                        <!-- 店舗名 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ field, errors }"
                            name="shopName"
                            :label="wordList.lbl_shop_name"
                            rules="max:100"
                          >
                            <v-autocomplete
                              :model-value="field.value ?? shopSelectValues"
                              density="compact"
                              :items="shopListItems"
                              item-title="name"
                              item-value="shop_code"
                              :label="wordList.lbl_shop_name"
                              :placeholder="wordList.plc_selectbox"
                              :no-data-text="wordList.lbl_no_data_text"
                              :error-messages="errors"
                              return-object
                              variant="outlined"
                              bg-color="#fff"
                              @update:model-value="
                                (val) => {
                                  field.onChange(val);
                                  shopSelectValues = val;
                                }
                              "
                              @blur="field.onBlur"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                        <!-- 所属グループ -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ field, errors }"
                            name="operatorGroup"
                            :label="wordList.lbl_operator_group"
                            rules="required|max:100"
                          >
                            <v-autocomplete
                              :model-value="field.value ?? groupSelectValues"
                              density="compact"
                              :items="groupRadioItems"
                              item-title="item"
                              item-value="index"
                              :label="wordList.lbl_operator_group"
                              :placeholder="wordList.plc_selectbox"
                              :no-data-text="wordList.lbl_no_data_text"
                              :error-messages="errors"
                              return-object
                              variant="outlined"
                              bg-color="#fff"
                              @update:model-value="
                                (val) => {
                                  field.onChange(val);
                                  groupSelectValues = val;
                                  onClickGroup();
                                }
                              "
                              @blur="field.onBlur"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                        <!-- 権限 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ field, errors }"
                            name="authType"
                            :label="wordList.lbl_auth_type"
                            rules="required|max:100"
                          >
                            <v-autocomplete
                              :model-value="field.value ?? authtypeSelectValues"
                              density="compact"
                              :items="authtypeRadioItems"
                              item-title="item"
                              item-value="index"
                              :label="wordList.lbl_auth_type"
                              :placeholder="wordList.plc_selectbox"
                              :no-data-text="wordList.lbl_no_data_text"
                              :error-messages="errors"
                              return-object
                              variant="outlined"
                              bg-color="#fff"
                              @update:model-value="
                                (val) => {
                                  field.onChange(val);
                                  authtypeSelectValues = val;
                                }
                              "
                              @blur="field.onBlur"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                        <!-- オペレータID -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field v-slot="{ field, errors }" name="operatorId" :label="wordList.lbl_operator_id" rules="max:10|regex:^[0-9a-zA-Z-_]+$">
                            <v-text-field
                              :model-value="field.value ?? searchConditionId"
                              :label="wordList.lbl_operator_id"
                              bg-color="#fff"
                              density="compact"
                              variant="outlined"
                              clearable
                              :error-messages="errors"
                              @update:model-value="
                                (val) => {
                                  field.onChange(val);
                                  searchConditionId = val;
                                }
                              "
                              @blur="field.onBlur"
                            ></v-text-field>
                          </Field>
                        </v-col>
                        <!-- 登録名称 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ field, errors }"
                            name="operatorRegistName"
                            :label="wordList.lbl_operator_regist_name"
                            rules="max:10"
                          >
                            <v-text-field
                              :model-value="field.value ?? searchConditionName"
                              :label="wordList.lbl_operator_regist_name"
                              bg-color="#fff"
                              density="compact"
                              variant="outlined"
                              clearable
                              :error-messages="errors"
                              @update:model-value="
                                (val) => {
                                  field.onChange(val);
                                  searchConditionName = val;
                                }
                              "
                              @blur="field.onBlur"
                            ></v-text-field>
                          </Field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                        <v-btn
                          variant="flat"
                          color="primary"
                          class="px-16 mt-6"
                          :disabled="!meta.valid || isSearchDisabled"
                          @click="onClickSearch"
                        ><v-icon>mdi-magnify</v-icon
                        >{{ wordList.lbl_search }}</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </Form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- 検索条件入力 } -->
          <!-- 一覧表示  { -->
          <v-card :flat="true" width="100%">
            <v-data-table-server
              v-model="selectListCheckbox"
              item-key="id"
              :items-per-page="listOptions.itemsPerPage"
              :options="listOptions"
              :items="listDataArray"
              :items-length="listDataTotalCount"
              :loading="listLoading"
              :no-data-text="wordList.lbl_no_data_text"
              hide-default-footer
              show-select
              return-object
              :headers="tableHeaders"
              :row-props="() => ({ class: 'bk_gray_1' })"
              @update:options="onUpdateOptions"
            >
              <template #top>
                <v-row>
                  <v-col
                    cols="12"
                    class="d-flex justify-space-between mt-9 mb-5"
                  >
                    <div class="d-flex align-center">
                      <span class="pl-3">全 {{ listDataTotalCount }} 件 </span
                      ><span class="pl-1"> {{ displayPagingRange }} </span>
                      <v-pagination
                        v-model="listOptions.page"
                        :length="pageCount"
                        :total-visible="7"
                        variant="elevated"
                        density="comfortable"
                      >
                      </v-pagination>
                    </div>
                    <div v-if="!isXs">
                      <v-menu open-on-hover location="bottom">
                        <template #activator="{ props }">
                          <v-btn
                            v-bind="props"
                            variant="text"
                            color="black"
                            class="pr-0 pl-2"
                          >
                            アクション
                            <v-icon>mdi-cog</v-icon>
                          </v-btn>
                        </template>
                        <v-list width="250" class="pl-5">
                          <v-list-item-title
                            style="cursor: pointer"
                            @click="onClickCheckDelete"
                          >
                            <v-icon class="mr-2">mdi-delete</v-icon
                            >{{ wordList.btn_delete_all }}
                          </v-list-item-title>
                        </v-list>
                      </v-menu>
                    </div>
                  </v-col>
                </v-row>
              </template>
              <template #[`item.actions`]="{ item }">
                <div>
                  <v-btn
                    variant="outlined"
                    color="primary"
                    size="x-small"
                    class="my-2 ml-2 rounded-full"
                    icon
                    @click="onClickEdit(item.id)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    color="red"
                    size="x-small"
                    class="my-2 ml-2 mr-0 rounded-full"
                    variant="outlined"
                    icon
                    @click="onClickDelete(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table-server>
          </v-card>
        </v-card>
      </v-card-text>
    </v-card>
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
    <!-- オペレータ個別削除確認 -->
    <v-card v-if="confirmPage" :flat="true">
      <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
        {{ wordList.lbl_operator_delete_confirm }}
      </v-card-title>
      <v-card-text>
        <!-- 同じIDは再利用できない旨の注意メッセージ -->
        <v-row dense class="mb-3">
          <v-col cols="12">
            <span style="font-weight: bold; font-size: 1.15rem">
              {{ wordList.msg_w_delete_operator }}
            </span>
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 店舗名 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_shop_name }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteItem.shopName }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- オペレータID -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_operator_id }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteItem.id }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- オペレータ名 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_operator_regist_name }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteItem.name }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 所属グループ -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
            ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_operator_group }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteItem.group }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 権限 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_auth_type }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteItem.authType }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 個人情報閲覧 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_personal_info_browsing }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteItem.personalInfo }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 個人情報ダウンロード -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_personal_info_download }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1 d-flex align-center">
            {{ deleteItem.personalInfoDl }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-center flex-wrap py-10">
        <v-btn
          variant="flat"
          color="return"
          class="px-16 my-2 mx-2"
          @click="onClickConfirmDeleteCancel"
        >
          <v-icon>mdi-arrow-left</v-icon>
          {{ wordList.btn_return }}
        </v-btn>
        <v-btn
          variant="flat"
          color="primary"
          class="px-16 my-2 mx-2"
          @click="onClickDeleteComplete"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_delete_complete }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay
      :model-value="overlay"
      class="d-flex align-center justify-center"
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- 一括削除確認ダイアログ {-->
    <v-dialog
      v-model="confirmDeleteDialog"
      content-class="dialog_width_1"
      :lock-scroll="false"
      scrollable
    >
      <v-data-iterator
        :items="selectListCheckbox"
        item-key="name"
        hide-default-footer
        :items-per-page="-1"
      >
        <template #default="{ items }">
          <v-card class="rounded-t rounded-b-0">
            <v-card-title class="bg-red mb-5" style="color: white"
              >一括削除内容確認</v-card-title
            >
            <v-card-text class="font-weight-black"
              >{{ selectListCheckbox.length }}
              件のオペレータを削除します。
              <span style="font-weight: bold; font-size: 0.95rem">
                <br />
                {{
                  selectListCheckbox.length > 1
                    ? wordList.msg_w_delete_operator.replace(
                        "このID",
                        "これらのID"
                      )
                    : wordList.msg_w_delete_operator
                }}
              </span>
            </v-card-text>
            <v-card-text style="max-height: 60vh; overflow-y: auto;">
              <v-card
                v-for="item in items"
                :key="item.raw.id"
                :flat="true"
                variant="outlined"
                class="mb-5"
              >
                <v-card-title>
                  <h4>{{ wordList.lbl_operator_id }} : {{ item.raw.id }}</h4>
                </v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-list density="compact">
                  <!-- 店舗名 -->
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="4"
                        md="4"
                        lg="4"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_shop_name }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.shopName }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <!-- オペレータID -->
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="4"
                        md="4"
                        lg="4"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_operator_id }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.id }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <!-- オペレータ名 -->
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="4"
                        md="4"
                        lg="4"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_operator_regist_name }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.name }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <!-- 所属グループ -->
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="4"
                        md="4"
                        lg="4"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_operator_group }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.group }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <!-- 権限 -->
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="4"
                        md="4"
                        lg="4"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_auth_type }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.authType }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <!-- 個人情報閲覧 -->
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="4"
                        md="4"
                        lg="4"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_personal_info_browsing }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.personalInfo }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <!-- 個人情報ダウンロード -->
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="4"
                        md="4"
                        lg="4"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_personal_info_download }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.personalInfoDl }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-card-text>
          </v-card>
        </template>
        <template #footer>
          <v-card variant="flat" class="py-4 rounded-b rounded-t-0">
            <v-row justify="center">
              <!-- 戻るボタン -->
              <v-btn
                variant="flat"
                color="return"
                class="px-16 mx-2 my-2"
                width="168px"
                @click="confirmDeleteDialog = false"
              >
                <v-icon>mdi-arrow-left</v-icon>
                {{ wordList.btn_return }}</v-btn
              >
              <v-btn
                variant="outlined"
                class="bg-red-darken-1 mx-2 my-2"
                color="white"
                width="168px"
                @click="onClickCheckDeleteComplete"
                >{{ wordList.btn_delete_all }}</v-btn
              >
            </v-row>
          </v-card>
        </template>
      </v-data-iterator>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>
    <!-- } 削除確認ダイアログ -->
  </v-container>
</template>

<script setup lang="ts">
import { onMounted, computed } from "vue";
import { useDisplay } from "vuetify";
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import { regex, required, max } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import AlertDialog from "@/components/AlertDialog.vue";

import { useOperatorListUiState } from "./composables/useOperatorListUiState";
import { useOperatorListSearchForm } from "./composables/useOperatorListSearchForm";
import { useOperatorListFilterOptions } from "./composables/useOperatorListFilterOptions";
import { useOperatorListTable } from "./composables/useOperatorListTable";
import { useOperatorListInit } from "./composables/useOperatorListInit";
import { useOperatorListDelete } from "./composables/useOperatorListDelete";
import { useOperatorListActions } from "./composables/useOperatorListActions";

defineRule("regex", regex);
defineRule("required", required);
defineRule("max", max);
configure({
  generateMessage: localize({ ja }),
});
setLocale('ja');

// Vuetify breakpoint
const { xs } = useDisplay();
const isXs = computed(() => xs.value);

// composables 初期化
const {
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  confirmDeleteDialog,
  overlay,
  panel,
} = useOperatorListUiState();

const {
  searchConditionId,
  searchConditionName,
} = useOperatorListSearchForm();

const {
  chainViewFlag,
  chainListItems,
  chainSelectValues,
  shopSelectValues,
  shopListItems,
  shopListInput,
  groupSelectValues,
  authtypeSelectValues,
  isOperatorGroupShopFlag,
  isOperatorGroupAdminFlag,
  isOperatorGroupOtherFlag,
  groupRadioItems,
  groupRadioItemsAll,
  groupRadioItemsAdmin,
  groupRadioItemsShop,
  authtypeRadioItems,
  authtypeRadioItemsAll,
  searchFormRef,
  formInitialValues,
  isSearchDisabled,
  onChangeChain,
  onClickGroup,
} = useOperatorListFilterOptions(errdialog, errMessage);

const {
  onClickEdit,
  isUpdateModeBack,
} = useOperatorListActions(
  editPage,
  chainSelectValues,
  shopSelectValues,
  groupSelectValues,
  authtypeSelectValues,
  searchConditionId,
  searchConditionName,
  () => listOptions.page,
);

const {
  tableHeaders,
  listLoading,
  listOptions,
  listDataArray,
  listDataTotalCount,
  pageCount,
  selectListCheckbox,
  displayPagingRange,
  onUpdateOptions,
  onClickSearch,
  searchQuery,
} = useOperatorListTable(
  chainViewFlag,
  chainSelectValues,
  shopSelectValues,
  groupSelectValues,
  authtypeSelectValues,
  searchConditionId,
  searchConditionName,
  errdialog,
  errMessage,
  groupRadioItemsAll,
  authtypeRadioItemsAll,
  isUpdateModeBack,
);

const {
  deleteItem,
  onClickDelete,
  onClickConfirmDeleteCancel,
  onClickDeleteComplete,
  onClickCheckDelete,
  onClickCheckDeleteComplete,
} = useOperatorListDelete(
  editPage,
  confirmPage,
  confirmDeleteDialog,
  overlay,
  errdialog,
  errMessage,
  selectListCheckbox,
  searchQuery,
);

const {
  wordList,
  isWordListReady,
  runInitialLoad,
} = useOperatorListInit(
  overlay,
  errdialog,
  errMessage,
  listLoading,
  chainViewFlag,
  chainListItems,
  chainSelectValues,
  shopListItems,
  shopSelectValues,
  shopListInput,
  groupRadioItems,
  groupSelectValues,
  authtypeRadioItems,
  authtypeSelectValues,
  searchFormRef,
  isOperatorGroupShopFlag,
  isOperatorGroupAdminFlag,
  isOperatorGroupOtherFlag,
  groupRadioItemsShop,
  groupRadioItemsAdmin,
  groupRadioItemsAll,
  searchConditionId,
  searchConditionName,
  onClickGroup,
  onClickSearch,
  isUpdateModeBack,
  listOptions,
);

onMounted(async () => {
  await runInitialLoad();
});
</script>

<style scoped></style>
